const Toggle = (event) => {
        const parent = event.target.closest(".nav-item").parentNode;
        const targetBtn = event.target.closest("button");
        const subNavItems = document.body.querySelectorAll(".dd");
        const clickedNavItem = parent.querySelector(".dd");
        const allNavBtns = document.body.querySelectorAll("li button");
    
        if (event.type === "click") {
          subNavItems.forEach((item) => {
            const open = clickedNavItem.classList.contains("!visible");
            if (item == clickedNavItem && !open) {
              clickedNavItem.classList.add("!visible");
              clickedNavItem.classList.add("!opacity-100");
              targetBtn.setAttribute("aria-expanded", "true");
            } else if (item != clickedNavItem || open) {
              item.classList.remove("!visible");
              item.classList.remove("!opacity-100");
              allNavBtns.forEach((btn) => {
                if (btn != targetBtn || (open && item == clickedNavItem)) {
                  btn.setAttribute("aria-expanded", "false");
                }
              });
            }
          });
          event.preventDefault();
        }
      };

export default Toggle;
